var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83 1.286h3.886a.645.645 0 0 0 .648-.643A.645.645 0 0 0 9.716 0H5.83a.645.645 0 0 0-.648.643c0 .355.29.643.648.643ZM7.773 2.57C3.48 2.571 0 6.025 0 10.286 0 14.546 3.48 18 7.773 18c4.292 0 7.772-3.454 7.772-7.714-.004-4.259-3.482-7.71-7.772-7.715Zm3.664 4.987L8.23 10.74a.651.651 0 0 1-1.084-.288.64.64 0 0 1 .168-.62l3.206-3.183a.651.651 0 0 1 1.083.288.64.64 0 0 1-.167.621Z",
    fill: "#212121",
    fillRule: "nonzero"
  })));
};
export default SvgTimer;